import { render, staticRenderFns } from "./SummaryBrandPlaceOfOrigin.vue?vue&type=template&id=6bc4d1f4"
import script from "./SummaryBrandPlaceOfOrigin.vue?vue&type=script&lang=js"
export * from "./SummaryBrandPlaceOfOrigin.vue?vue&type=script&lang=js"
import style0 from "./SummaryBrandPlaceOfOrigin.vue?vue&type=style&index=0&id=6bc4d1f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports